/**
 * Dev-mode mock for amazon-quicksight-embedding-sdk.
 *
 * Renders a fake dashboard UI with clickable navigation buttons that fire
 * the same PAGE_NAVIGATION events as the real SDK. Enables local E2E testing
 * of URL sync, browser back/forward, and deep-linking without AWS credentials.
 *
 * Usage: set REACT_APP_QUICKSIGHT_DEV_MOCK=true in your environment.
 */

const MOCK_DASHBOARDS = [
  { id: "aaaaaaaa-bbbb-cccc-dddd-eeeeeeeeeeee", name: "Standard Facilities 3.0" },
  { id: "11111111-2222-3333-4444-555555555555", name: "Attendance Overview" },
  { id: "99999999-8888-7777-6666-555544443333", name: "WiFi Analytics" },
]

export async function createEmbeddingContext() {
  return {
    async embedConsole(frameOptions, contentOptions) {
      const { container } = frameOptions
      const { onMessage } = contentOptions

      const wrapper = document.createElement("div")
      wrapper.setAttribute("data-testid", "qs-dev-mock")
      wrapper.style.cssText =
        "padding:24px;background:#f0f4ff;border:2px dashed #7c3aed;border-radius:8px;font-family:sans-serif;"

      const heading = document.createElement("h3")
      heading.textContent = "QuickSight Dev Mock"
      heading.style.cssText = "margin:0 0 8px;color:#7c3aed;"
      wrapper.appendChild(heading)

      const description = document.createElement("p")
      description.textContent = "Click a dashboard to simulate SDK navigation:"
      description.style.cssText = "margin:0 0 16px;color:#555;"
      wrapper.appendChild(description)

      MOCK_DASHBOARDS.forEach((dashboard) => {
        const btn = document.createElement("button")
        btn.textContent = dashboard.name
        btn.setAttribute("data-dashboard-id", dashboard.id)
        btn.style.cssText =
          "display:block;width:100%;padding:12px 16px;margin:0 0 8px;border:1px solid #7c3aed;" +
          "border-radius:6px;background:#fff;color:#333;font-size:14px;cursor:pointer;text-align:left;"

        btn.addEventListener("click", () => {
          onMessage({
            eventName: "PAGE_NAVIGATION",
            message: {
              pageType: "DASHBOARD",
              dashboardId: dashboard.id,
            },
          })
        })

        wrapper.appendChild(btn)
      })

      container.appendChild(wrapper)

      return {
        async close() {
          container.innerHTML = ""
        },
      }
    },
  }
}
